/* import __COLOCATED_TEMPLATE__ from './plan-trial-modal.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { assetUrl } from '@intercom/pulse/helpers/asset-url';

interface Signature {
  Args: {
    isOpen: boolean;
    onModalClose: () => void;
    planName: string;
  };
}

const BENEFIT_CARDS = {
  FIN_AI_AGENT: 'fin-ai-agent',
  HELPDESK: 'helpdesk',
  PROACTIVE_SUPPORT_PLUS: 'proactive-support-plus',
};

export default class PlanTrialModal extends Component<Signature> {
  @service intercomEventService: any;
  @service declare router: RouterService;

  listOfBenefits = Object.values(BENEFIT_CARDS);

  @action
  benefitCtaRoute(benefit: string): string {
    switch (benefit) {
      case BENEFIT_CARDS.FIN_AI_AGENT:
        return 'apps.app.automation.fin-ai-agent.content';
      case BENEFIT_CARDS.HELPDESK:
        return 'apps.app.settings.workspace.teammates';
      case BENEFIT_CARDS.PROACTIVE_SUPPORT_PLUS:
      default:
        return 'apps.app.outbound.all';
    }
  }

  @action
  benefitVideoId(benefit: string): string {
    switch (benefit) {
      case BENEFIT_CARDS.FIN_AI_AGENT:
        return '7xgvdmpwhy';
      case BENEFIT_CARDS.PROACTIVE_SUPPORT_PLUS:
        return '7xgvdmpwhy';
      default:
        return ''; // helpdesk tile does not have a video
    }
  }

  @action
  thumbnailAssetUrl(benefit: string): string {
    let thumbnailFileName = `plan-trial-modal-${benefit}-thumbnail.png`;
    return assetUrl(`/assets/images/banners/${thumbnailFileName}`);
  }

  @action
  handleModalClose() {
    this.args.onModalClose();
  }

  @action
  triggerTransition(benefit: string) {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: `${benefit}_cta`,
      section: 'banner-plan-trial-modal',
      place: 'banner-plan-trial-modal',
    });
    this.router.transitionTo(this.benefitCtaRoute(benefit));
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Banners::PlanTrialModal': typeof PlanTrialModal;
    'banners/plan-trial-modal': typeof PlanTrialModal;
  }
}
